import { Injectable } from '@angular/core';
import {
  NetworkUtilsService,
  URL_DICT,
} from 'projects/app-core/src/service/network-utils.service';
import { AddNewEmailTemplateReq } from '../models/email-templates/addEmailTemplateReq';
import { EmailTemplateGridRequest } from '../models/email-templates/emailTemplatesGridRequest';
import { EmailTemplateGridResponse } from '../models/email-templates/emailTemplateGridResponse';
import { EmailTemplate } from '../models/email-templates/emailTemplate';
import { EmailTemplateHistoryGridRequest } from '../models/email-templates/emailTemplatesHistoryGridRequest';
import { EmailTemplatesHistoryDataGridResponse } from '../models/email-templates/emailTemplatesHistoryGridResponse';

@Injectable({
  providedIn: 'root',
})
export class EmailTemplatesService {
  constructor(private api: NetworkUtilsService) {}

  public sendMailHtml(req: { html: string }) {
    return this.api.post(URL_DICT.emailTesting, req);
  }

  public addEmailTemplate(req: AddNewEmailTemplateReq) {
    return this.api.post(URL_DICT.addEmailTemplateUrl, req);
  }

  public getTags() {
    return this.api.get<string[]>(URL_DICT.getEmailTemplateTagsUrl);
  }

  public emailTemplatesGridlist(req: EmailTemplateGridRequest) {
    return this.api.post<EmailTemplateGridResponse>(
      URL_DICT.emailTemplatesGridUrl,
      req,
    );
  }

  public getEmailTemplateId(id: string) {
    return this.api.get<EmailTemplate>(URL_DICT.emailTemplateGetUrl + id);
  }

  public updateEmailTemplate(id: string, req: AddNewEmailTemplateReq) {
    return this.api.post(URL_DICT.emailTemplateUpdatePostUrl + id, req);
  }

  public getEmailtemplatesLogsGrid(gridRequest: EmailTemplateHistoryGridRequest){
    return this.api.post<EmailTemplatesHistoryDataGridResponse>(URL_DICT.emailTemplateHistoryGetUrl,gridRequest);
  }
}
